// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--365y-","title":"_80ad21f8ef--title--34iEj","subtext":"_80ad21f8ef--subtext--1Py3u","video-container":"_80ad21f8ef--video-container--3q5Yd"};